<template lang="pug">
div
  .odds.text-muted(v-if="this.vg1.includes(menu2)")
    i.fad.fa-lock-alt
  .odd-box(v-else)
    .odd.lock
      i.fad.fa-lock-alt
</template>

<script>
import config from "@/config";

export default {
  computed: {
    vg1() {
      return config.vg1;
    },
    menu2() {
      return this.$store.getters.menu2;
    }
  }
}
</script>